<template>
    <div class="w-full h-auto">
        <svg
            class="w-full"
            fill="none"
            viewBox="0 0 345 207"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#wrapper)">
                <path
                    :fill="backgroundColor"
                    d="M343 0H-2V207H343V0Z"
                />
                <mask
                    id="shadow"
                    height="10"
                    maskUnits="userSpaceOnUse"
                    style="mask-type: luminance"
                    width="345"
                    x="-2"
                    y="202"
                >
                    <path
                        d="M7.76415 206.842C7.76415 209.449 5.48585 211.443 2.88208 211.443C0.278302 211.443 -2 209.296 -2 206.842C-2 204.389 0.278302 202.242 2.88208 202.242C5.48585 202.242 7.76415 204.389 7.76415 206.842ZM22.4104 202.242C19.6439 202.242 17.5283 204.389 17.5283 206.842C17.5283 209.296 19.8066 211.443 22.4104 211.443C25.0142 211.443 27.2925 209.296 27.2925 206.842C27.2925 204.389 25.0142 202.242 22.4104 202.242ZM42.1014 202.242C39.3349 202.242 37.2193 204.389 37.2193 206.842C37.2193 209.296 39.4976 211.443 42.1014 211.443C44.7052 211.443 46.9835 209.296 46.9835 206.842C46.9835 204.389 44.7052 202.242 42.1014 202.242ZM61.7925 202.242C59.0259 202.242 56.9104 204.389 56.9104 206.842C56.9104 209.296 59.1887 211.443 61.7925 211.443C64.3962 211.443 66.6745 209.296 66.6745 206.842C66.6745 204.389 64.3962 202.242 61.7925 202.242ZM81.4835 202.242C78.717 202.242 76.6014 204.389 76.6014 206.842C76.6014 209.296 78.8797 211.443 81.4835 211.443C84.0873 211.443 86.3656 209.296 86.3656 206.842C86.3656 204.389 84.0873 202.242 81.4835 202.242ZM101.175 202.242C98.408 202.242 96.2925 204.389 96.2925 206.842C96.2925 209.296 98.5708 211.443 101.175 211.443C103.778 211.443 106.057 209.296 106.057 206.842C106.057 204.389 103.778 202.242 101.175 202.242ZM120.866 202.242C118.099 202.242 115.983 204.389 115.983 206.842C115.983 209.296 118.262 211.443 120.866 211.443C123.469 211.443 125.748 209.296 125.748 206.842C125.748 204.389 123.469 202.242 120.866 202.242ZM140.557 202.242C137.79 202.242 135.675 204.389 135.675 206.842C135.675 209.296 137.953 211.443 140.557 211.443C143.16 211.443 145.439 209.296 145.439 206.842C145.439 204.389 143.16 202.242 140.557 202.242ZM160.248 202.242C157.481 202.242 155.366 204.389 155.366 206.842C155.366 209.296 157.644 211.443 160.248 211.443C162.851 211.443 165.13 209.296 165.13 206.842C165.13 204.389 162.851 202.242 160.248 202.242ZM179.939 202.242C177.172 202.242 175.057 204.389 175.057 206.842C175.057 209.296 177.335 211.443 179.939 211.443C182.542 211.443 184.821 209.296 184.821 206.842C184.821 204.389 182.542 202.242 179.939 202.242ZM199.63 202.242C196.863 202.242 194.748 204.389 194.748 206.842C194.748 209.296 197.026 211.443 199.63 211.443C202.233 211.443 204.512 209.296 204.512 206.842C204.512 204.389 202.233 202.242 199.63 202.242ZM219.321 202.242C216.554 202.242 214.439 204.389 214.439 206.842C214.439 209.296 216.717 211.443 219.321 211.443C221.925 211.443 224.203 209.296 224.203 206.842C224.203 204.389 221.925 202.242 219.321 202.242ZM239.012 202.242C236.245 202.242 234.13 204.389 234.13 206.842C234.13 209.296 236.408 211.443 239.012 211.443C241.616 211.443 243.894 209.296 243.894 206.842C243.894 204.389 241.616 202.242 239.012 202.242ZM258.703 202.242C255.936 202.242 253.821 204.389 253.821 206.842C253.821 209.296 256.099 211.443 258.703 211.443C261.307 211.443 263.585 209.296 263.585 206.842C263.585 204.389 261.307 202.242 258.703 202.242ZM278.394 202.242C275.627 202.242 273.512 204.389 273.512 206.842C273.512 209.296 275.79 211.443 278.394 211.443C280.998 211.443 283.276 209.296 283.276 206.842C283.276 204.389 280.998 202.242 278.394 202.242ZM298.248 202.242C295.481 202.242 293.366 204.389 293.366 206.842C293.366 209.296 295.644 211.443 298.248 211.443C300.851 211.443 303.13 209.296 303.13 206.842C303.13 204.389 300.851 202.242 298.248 202.242ZM317.939 202.242C315.172 202.242 313.057 204.389 313.057 206.842C313.057 209.296 315.335 211.443 317.939 211.443C320.542 211.443 322.821 209.296 322.821 206.842C322.821 204.389 320.542 202.242 317.939 202.242ZM337.63 202.242C334.863 202.242 332.748 204.389 332.748 206.842C332.748 209.296 335.026 211.443 337.63 211.443C340.233 211.443 342.512 209.296 342.512 206.842C342.512 204.389 340.233 202.242 337.63 202.242Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#shadow)">
                    <path
                        d="M346.591 1.22266H-6.38281V208.373H346.591V1.22266Z"
                        fill="white"
                    />
                </g>
                <text
                    x="16"
                    y="16"
                >
                    <tspan
                        v-for="word in typeWords"
                        :key="word"
                        :x="16"
                        :y="64 + typeWords.indexOf(word) * 54"
                        class="voucher-text voucher-text-large"
                    >
                        {{ word }}
                    </tspan>
                </text>
                <text
                    x="16"
                    y="160"
                >
                    <tspan
                        class="voucher-text voucher-text-small"
                        v-text="subtitle"
                    />
                </text>
                <defs>
                    <clipPath id="wrapper">
                        <rect
                            fill="white"
                            height="206.997"
                            width="345"
                        />
                    </clipPath>
                </defs>
            </g>
        </svg>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
    subtitle: string | null;
    benefitType: REWARD_TYPE;
    title: string;
}>();

const typeWords = computed(() => {
    const words = props.title.split(" ");

    return words.filter((word) => word.trim().length > 0);
});

const backgroundColor = computed(() => {
    switch (props.benefitType) {
        case "ROYAL_DAYS":
        case "LOYALTY_DAYS":
            return "#000000";
        default:
            return "#3C3D5D";
    }
});
</script>

<style scoped>
@reference "../../../../assets/css/app.css";

.voucher-text {
    @apply font-sans fill-beige-warm uppercase block;
}

.voucher-text-large {
    font-size: 56px;
    line-height: 62px;
    letter-spacing: 0.1em;
}

.voucher-text-small {
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.2em;
}
</style>
